import axios from 'axios';

export default async fileUrl => axios(fileUrl, { responseType: 'blob' })
  .then(({ data }) => {
    const url = window.URL.createObjectURL(data);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'receptacles_template';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  });
